import {action, observable, runInAction} from 'mobx'
import {decorate, inject, injectable} from '@yosmanyga/di'
import {CredentialManager} from '@yosmanyga/base';
import {AuthenticationFrontendAsGuestAbstractApi} from '../../data'

class AuthenticationFrontendAsGuestController {
    @observable accessor error!: string
    @observable accessor completing: boolean

    constructor(
        private authenticationFrontendAsGuestAbstractApi: AuthenticationFrontendAsGuestAbstractApi,
        private credentialManager: CredentialManager,
    ) {
        this.completing = false
    }

    @action complete = async () => {
        runInAction(() => {
            this.completing = true
        })

        const credential = await this.authenticationFrontendAsGuestAbstractApi.complete()
        await this.credentialManager.save(credential);

        runInAction(() => {
            this.completing = false
        })
    }
}

decorate(injectable(), AuthenticationFrontendAsGuestController)
decorate(inject(AuthenticationFrontendAsGuestAbstractApi), AuthenticationFrontendAsGuestController, 0)
decorate(inject(CredentialManager), AuthenticationFrontendAsGuestController, 1)

export {
    AuthenticationFrontendAsGuestController
}
